import { defineTheme } from '../utils'

export const christmas = defineTheme({
  themeLogo: {
    image: 'hidden',
  },
  page: {
    menuSection: 'mx-4 my-8 w-auto max-w-184 border-2 border-secondary/40 px-4 py-12 md:mx-auto md:px-10 md:py-16',
    menuGrid: 'grid w-full gap-12',
    menuNotice: 'mb-10 text-center text-xs tracking-[0.15em] text-white/60 uppercase [&_strong]:font-normal',
    heading: 'font-heading text-5xl italic md:text-6xl',
    menuHeading: 'mb-2 text-center font-heading text-5xl italic md:text-6xl',
    menuDescription: 'mb-8 text-center text-sm text-white/80',
    filterNoResults: 'py-12 text-center text-lg text-white/60',
  },
  menuTitleBlock: {
    base: 'text-center',
    title: 'font-heading text-4xl italic md:text-5xl',
  },
  menuCategory: {
    base: 'grid gap-6 text-center before:mb-2 before:block before:text-sm before:tracking-[0.6em] before:text-secondary before:content-["★★★★"] first:before:hidden',
    title: 'text-base font-bold tracking-[0.25em] text-secondary uppercase',
    description: 'mt-1 font-heading text-lg text-white/80 italic',
  },
  menuSubCategory: {
    base: 'grid gap-5 text-center',
    title: 'text-sm font-bold tracking-[0.2em] text-secondary uppercase',
    description: 'mt-1 font-heading text-base text-white/80 italic',
  },
  menuItem: {
    dinner: {
      base: 'dinner-base flex flex-col items-center gap-1.5 text-center',
      title: 'text-lg font-bold tracking-wide uppercase',
      description: 'order-2 max-w-md text-sm leading-relaxed text-white/85',
      priceList: 'order-1 font-heading text-lg text-secondary italic',
      priceItem: 'flex justify-center gap-1',
      icons: 'order-3 mt-1 flex justify-center gap-2',
      label: 'order-4 mt-1 font-heading text-sm text-secondary italic',
    },
    drinks: {
      base: 'flex flex-col items-center gap-1.5 text-center',
      title: 'text-lg font-bold tracking-wide uppercase',
      description: 'order-2 max-w-md text-sm leading-relaxed text-white/85',
      priceList: 'order-1 font-heading text-lg text-secondary italic',
      priceItem: 'flex justify-center gap-1',
      icons: 'order-3 mt-1 flex justify-center gap-2',
      label: 'order-4 mt-1 font-heading text-sm text-secondary italic',
    },
  },
  menuTextBlock: {
    base: 'border-y border-secondary/30 px-4 py-8 text-center',
    title: 'mb-2 font-heading text-3xl text-secondary italic',
    description: 'text-sm leading-relaxed text-white/85',
  },
  allergiesList: {
    heading: 'mb-4 flex items-center gap-2 font-heading text-2xl text-secondary italic md:text-3xl',
    filterLink: 'ml-auto cursor-pointer text-sm font-normal text-secondary underline',
    groupHeading: 'mt-6 mb-3 flex items-center gap-2 text-base font-bold tracking-[0.15em] text-secondary uppercase',
  },
  languageButton: {
    base: 'w-full border border-secondary px-4 py-3 text-center tracking-[0.2em] uppercase transition-colors hover:bg-secondary hover:text-background',
  },
  filterBar: {
    bar: 'border-b border-secondary/30 bg-background text-secondary',
    barTitle: 'font-semibold tracking-[0.15em] uppercase',
    popover: 'bg-background md:border md:border-secondary/30',
    popoverHeader: 'border-b border-secondary/30 bg-background',
    popoverTitle: 'tracking-[0.15em] text-secondary uppercase',
    closeButton: 'bg-secondary text-background hover:bg-secondary/80',
    stickyHeader: 'bg-background',
    search: 'border-b border-secondary/30 bg-background',
    searchInput: 'border-secondary/40 bg-transparent text-white placeholder:text-white/40 focus:border-secondary',
    searchEmpty: 'text-white/60',
    tabList: 'border-b border-secondary/30 bg-background',
    tab: 'text-white/60 hover:text-white',
    tabActive: 'border-secondary text-secondary',
    allergenInfo: 'text-white/60',
    masterItem: 'border-secondary/20 hover:bg-white/5',
    listItem: 'border-secondary/20 hover:bg-white/5',
    subItem: 'border-secondary/20 hover:bg-white/5',
    groupLabel: 'text-secondary',
    groupSeparator: 'border-secondary/30',
    checkbox: 'accent-secondary',
    itemLabel: 'text-white',
    popoverFooter: 'border-t border-secondary/30',
    resetButton: 'border-secondary/40 text-white hover:bg-white/5',
    applyButton: 'bg-secondary text-background hover:bg-secondary/80',
  },
})
